<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13uTGph/images/samantha-starr-series---vanished---cover.jpg?1684305978782" alt="This image is the cover for the book Vanished (A Samantha Starr Thriller, Book 5), A Samantha Starr Thriller"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Vanished (A Samantha Starr Thriller, Book 5), A Samantha Starr Thriller
      </h1>
      <p class="bookDescription body article font2">
        <b>Samantha Starr races the clock to decipher a riddle and ransom the man she loves in <i>Vanished,</i> a heart-pounding adventure from S.L. Menear</b><br/><br/><i>-- Egypt, Present Day --</i><br/><br/>When Special Air Service Captain Ross Sinclair is taken prisoner by Lord Edgar Sweetwater, it's up to airline pilot Samantha Starr to rescue him. But the price of Ross’s freedom is the Blue Dragon Diamond, lost in Africa thousands of years ago.<br/><br/>Aided by an Atlantis artifact, Samantha and her makeshift team race the clock to locate the enormous diamond and trade it for the man who owns Sam’s heart.<br/><br/>But the diamond Sam seeks is no ordinary gem, it's not even an extraordinary gem...it’s proof of a power beyond anything the modern world can imagine.<br/><br/><b>Publisher's Note:</b> As a retired airline pilot with U.S. Airways, S.L. Menear brings unparalleled realism and authenticity to this action-packed thriller with fantasy elements. Witten without vulgarity and explicit sexual content, this thrill-a-minute adventure can be enjoyed by readers of all ages and persuasions.<br/><br/>This book, along with others in this series, is also available in Paperback as well as a Large Print paperback.<br/><br/><b>The Samantha Starr Thriller Series</b><br/><i>Flight to Redemption<br/>Flight to Destiny<br/>Triple Threat<br/>Stranded<br/>Vanished</i><br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        S.L. Menear
      </h2>
      
      <p class="authorDescription body article">S.L. Menear is a retired airline pilot. US Airways hired Sharon in 1980 as their first female pilot, bypassing the flight engineer position. The men in her new-hire class gave her the nickname Bombshell. She flew Boeing 727s and 737s, DC-9s, and BAC 1-11 jet airliners and was promoted to captain in her seventh year.<br><br>Before her pilot career, Sharon worked as a water-sports model and then traveled the world as a flight attendant with Pan American World Airways.<br><br>Sharon has enjoyed flying antique airplanes, experimental aircraft, and Third-World fighter airplanes. Her leisure activities included scuba diving, powered paragliding, snow skiing, surfing, horseback riding, aerobatic flying, sailing, and driving fast cars and motorcycles.<br><br>Her beloved timber-shepherds, Pratt & Whitney, were her faithful companions for almost fourteen years, and she enjoyed riding her beautiful black and white paint stallion, Chief, who kept the mares happy, fathering several adorable foals on her mother’s horse ranch in Texas.<br><br>Sharon has flown many of the airplanes in her debut novel, <i>Flight to Redemption, Flight to Destiny, Triple Threat, and Vanished,</i> Books One through Four in her Samantha Starr Thriller Series featuring a woman airline pilot.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      ePublishing Works!
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?eb30315e